var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$A[_vm.A])?_c('Button',{staticClass:"btn",attrs:{"size":_vm.size,"type":_vm.getType(_vm.A),"custom-icon":_vm.getIocn(_vm.A)},on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.getTitle(_vm.A)))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }